<div class="scheduler__event-modal">
  <form [formGroup]="eventForm" (ngSubmit)="onSubmit()">
    <div class="modal-header container-fluid d-block">
      <div class="row">
        <div class="scheduler__modal-datepicker col-10">
          <i (click)="dpicker.toggle()" class="far fa-calendar scheduler__modal-datepicker-calendar-icon"></i>
          <input (click)="dpicker.toggle()" readonly class="scheduler__modal-datepicker-input"
                 placeholder="Select a Date" [minDate]="todayDate" name="dp" formControlName="eventDate"
                 ngbDatepicker #dpicker="ngbDatepicker">
          <i (click)="dpicker.toggle()" class="scheduler__datepicker-toggle-icon fas fa-angle-down"></i>
        </div>
        <div class="col-2 text-right">
          <a class="scheduler__modal-close" (click)="dismissModal($event)">
            <i class="fas fa-times"></i>
          </a>
        </div>
      </div>
    </div>
    <div class="modal-body scheduler__modal-body">
      <div class="form-group scheduler-form-group">
        <select [attr.disabled]="eventFlag.value ? '' : null"
                [class.is-invalid]="eventType.invalid && (eventType.dirty || eventType.touched)"
                class="form-control scheduler__form-control scheduler__form-control-select" id="eventType"
                formControlName="eventType">
          <option *ngFor="let item of eventtypes" value="{{item.Name}}">
            {{item.Name}}
          </option>
        </select>
        <label for="eventType" class="scheduler__form-control-select-icon fas fa-angle-down"></label>
      </div>
      <div class="form-group scheduler-form-group">
        <input type="text" [class.is-invalid]="eventName.invalid && (eventName.dirty || eventName.touched)"
               class="form-control scheduler__form-control" id="schedulerTitle" placeholder="Add a title"
               formControlName="eventName" maxlength="25">
      </div>
      <div class="form-group scheduler-form-group">
        <input type="text" [class.is-invalid]="eventDesc.invalid && (eventDesc.dirty || eventDesc.touched)"
               class="form-control scheduler__form-control" id="schedulerDescription" placeholder="Description"
               maxlength="60" formControlName="eventDesc">
      </div>
      <div class="row mx-0 scheduler__time-picker">
        <div class="pl-0 col-1 scheduler__modal-form-clock"><i class="far fa-clock"></i></div>
        <div class="col-11 pl-3">
          <div class="row">
            <div class="form-group scheduler-form-group m-0 col-6 pr-0 pl-2">
              <select [class.is-invalid]="(eventStartTime.invalid || eventForm.errors?.timeNotValid) && (eventStartTime.dirty || eventStartTime.touched)"
                      class="form-control scheduler__form-control scheduler__form-control-select"
                      id="startTime" formControlName="eventStartTime">
                <option [ngValue]="null" disabled>{{constants.startTime}}</option>
                <option *ngFor="let time of times" value="{{time.value}}">{{time.label}}</option>
              </select>
              <i class="scheduler__form-control-select-icon fas fa-angle-down"></i>
            </div>
            <div class="form-group scheduler-form-group m-0 col-6 pr-0 pl-2">
              <select [class.is-invalid]="(eventEndTime.invalid || eventForm.errors?.timeNotValid) && (eventEndTime.dirty || eventEndTime.touched)"
                      class="form-control scheduler__form-control scheduler__form-control-select" id="endTime"
                      formControlName="eventEndTime">
                <option [ngValue]="null" disabled>{{constants.endTime}}</option>
                <option *ngFor="let time of times" value="{{time.value}}">{{time.label}}</option>
              </select>
              <i class="scheduler__form-control-select-icon fas fa-angle-down"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="row scheduler__form-flag">
        <div class="col-9">
          <span class="scheduler__form-flag-label">{{constants.flagged}}</span>
        </div>
        <div class="col-3 form-check form-switch text-right">
          <input type="checkbox" class="form-check-input" formControlName="eventFlag" color="#2374BB" />
        </div>
      </div>
    </div>
    <div class="scheduler__modal-footer">
      <div [ngClass]="{'row align-items-center': shouldUpdateDelete}">
        <div class="d-inline-block" [ngClass]="{'col-md-6 col-3': shouldUpdateDelete}"
             [class.mr-4]="!shouldUpdateDelete">
          <a (click)="dismissModal($event)" href="#"
             class="scheduler__form-cancel">{{constants.cancelLabel}}</a>
        </div>
        <button *ngIf="!shouldUpdateDelete" type="submit" [disabled]="!eventForm.valid"
                class="scheduler-btn scheduler-btn-primary btn btn-primary">
          {{constants.createLabel}}
        </button>
        <div *ngIf="shouldUpdateDelete" class="scheduler__modal-update-delete col pl-0">
          <button type="button" [disabled]="!eventForm.valid"
                  class="scheduler-btn scheduler-btn-primary-outline btn btn-primary"
                  (click)="modifyEvent()">
            Save
          </button>
          <button type="button" class="scheduler-btn scheduler-btn-alert btn btn-alert"
                  (click)="deleteEvent()">
            {{constants.deleteLabel}}
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
